import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 5000);
    }
  };

  return (
    <footer className="footer-site-modern">
      <div className="container">
        <div className="row g-4 py-5">
          {/* Col 1: Bio & Credentials */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand-wrap mb-3">
              <Link to="/" className="d-flex align-items-center gap-3 text-decoration-none">
                <img
                  src="/images/logo_new.png"
                  alt="Dr. Sunil Apsingi"
                  className="footer-logo"
                />
                <div>
                  <h4 className="footer-brand-title mb-0">Dr. Sunil Apsingi</h4>
                  <small className="text-teal font-monospace">MS Ortho (PGI Chandigarh)</small>
                </div>
              </Link>
            </div>
            <p className="footer-text-muted">
              Senior Consultant Orthopedic, Arthroscopy & Joint Replacement Surgeon with 23+ years of surgical excellence in complex knee, shoulder, and robotic reconstructive procedures.
            </p>
            <div className="footer-social-links mt-3">
              <a
                href="https://www.youtube.com/channel/UCAJw_WKgtOHK20IDvGZYcvA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="social-pill"
              >
                <i className="fa-brands fa-youtube"></i>
              </a>
              <a
                href="https://twitter.com/sapsingi"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className="social-pill"
              >
                <i className="fa-brands fa-x-twitter"></i>
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="social-pill"
              >
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="social-pill"
              >
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>
          </div>

          {/* Col 2: Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h5 className="footer-col-heading">Quick Links</h5>
            <ul className="footer-nav-list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/aboutus">About Doctor</Link></li>
              <li><Link to="/services">Surgical Services</Link></li>
              <li><Link to="/blogs">Health Articles</Link></li>
              <li><Link to="/gallery">Surgical Gallery</Link></li>
              <li><Link to="/usefullinks">Patient Resources</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Col 3: Clinic Location & Working Hours */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-col-heading">Clinic Information</h5>
            <div className="footer-contact-block">
              <div className="d-flex gap-3 mb-3">
                <i className="fa-solid fa-hospital text-teal mt-1"></i>
                <span className="footer-info-text">Medicover Out Patient Center, HUDA Techno Enclave, HITEC City, Hyderabad, 500081</span>
              </div>
              <div className="d-flex gap-3 mb-3">
                <i className="fa-solid fa-clock text-teal mt-1"></i>
                <div>
                  <strong className="footer-info-label d-block text-white">Consultation Hours:</strong>
                  <div className="footer-timing-badge mt-1">
                    <i className="fa-regular fa-calendar-check me-1 text-teal"></i> Mon - Sat: 10:00 AM - 04:00 PM
                  </div>
                </div>
              </div>
              <div className="d-flex gap-3 mb-2">
                <i className="fa-solid fa-phone text-teal mt-1"></i>
                <a href="tel:+918341555765" className="footer-phone-link">
                  +91 8341555765
                </a>
              </div>
            </div>
          </div>

          {/* Col 4: Newsletter */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-col-heading">Health Updates</h5>
            <p className="footer-text-muted">
              Subscribe to receive verified joint care guidance, surgery recovery tips, and clinical updates.
            </p>
            {subscribed ? (
              <div className="alert alert-success py-2 px-3 text-sm">
                <i className="fa-solid fa-check-circle me-1"></i> Thank you for subscribing!
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="footer-subscribe-form">
                <div className="input-group">
                  <input
                    type="email"
                    className="form-control footer-email-input"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit" className="btn btn-medical-primary px-3">
                    <i className="fa-solid fa-paper-plane"></i>
                  </button>
                </div>
              </form>
            )}
            <div className="mt-3">
              <Link to="/bookappointment" className="btn-medical-amber w-100 text-center">
                Book Consultation
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright & Developer Credit Bar */}
        <div className="footer-bottom-bar border-top py-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
          <p className="mb-0 footer-copyright-text small">
            © {new Date().getFullYear()} Dr. Sunil Apsingi. All Rights Reserved.
          </p>
          <p className="mb-0 footer-dev-text small">
            Design by{' '}
            <a
              href="https://instagram.com/sayikumarr"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-dev-link"
            >
              <i className="fa-brands fa-instagram me-1"></i>Sayikumarr
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
